// extracted by mini-css-extract-plugin
module.exports = {"sin_fondo":"Instituto__sin_fondo__3SdhP","fondo_azul":"Instituto__fondo_azul__1nkmw"};